// extracted by mini-css-extract-plugin
export var card = "styles-module--card--d902f";
export var cardImage = "styles-module--cardImage--55ccc";
export var cardLink = "styles-module--cardLink--3d84e";
export var full = "styles-module--full--22f8c";
export var gap2 = "styles-module--gap2--c4167";
export var gap3 = "styles-module--gap3--14ef1";
export var gap4 = "styles-module--gap4--b2f63";
export var half = "styles-module--half--b52a0";
export var innerSquare = "styles-module--innerSquare--e04eb";
export var pack2 = "styles-module--pack2--64d9e";
export var pack3 = "styles-module--pack3--fbba7";
export var pack4 = "styles-module--pack4--7fd5e";
export var square = "styles-module--square--3a704";